import { computed, defineComponent, onMounted } from "vue";
import CommonModule from "@/store/modules/common";
import AppModule from "@/store/modules/app";
/**
 * Component with countries
 *
 * @component
 * @example
 * <select-country/>
 */

export default defineComponent({
  name: "SelectCountry",
  setup: function setup() {
    var statuses = computed(function () {
      return CommonModule.countries;
    });
    onMounted(function () {
      CommonModule.fetchCountries({
        lang: AppModule.language
      });
    });
    return {
      statuses: statuses
    };
  }
});